import { render, staticRenderFns } from "./m-roster-data.vue?vue&type=template&id=8be455fc&scoped=true&"
import script from "./m-roster-data.ts?vue&type=script&lang=ts&"
export * from "./m-roster-data.ts?vue&type=script&lang=ts&"
import style0 from "./m-roster-data.scss?vue&type=style&index=0&id=8be455fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be455fc",
  null
  
)

export default component.exports